
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/oppningsdatum-for-skidorter",
      function () {
        return require("private-next-pages/[region]/oppningsdatum-for-skidorter.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/oppningsdatum-for-skidorter"])
      });
    }
  